import { html } from 'lit';
const LoomLogoDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#625DF5" d="M22 10.888h-5.848l5.065-2.924-1.113-1.927L15.04 8.96l2.924-5.065-1.927-1.113-2.924 5.065V2h-2.224v5.848L7.963 2.783 6.036 3.896 8.961 8.96 3.896 6.037 2.783 7.963l5.065 2.924H2v2.225h5.848l-5.065 2.924 1.113 1.927L8.96 15.04l-2.924 5.064 1.927 1.113 2.924-5.065V22h2.225v-5.848l2.923 5.065 1.927-1.113-2.924-5.065 5.065 2.924 1.113-1.927-5.065-2.923H22v-2.225zm-10 4.138a3.037 3.037 0 1 1 0-6.074 3.037 3.037 0 0 1 0 6.074"/>
  </svg>
`;
export default LoomLogoDuotone;
